import QuestionariosList from "@/modules/questionario-empresa/components/questionarios-list";
// prettier-ignore
const QuestionarioEmpresaPage = () => {
  return (
    <QuestionariosList />
  );
};

export default QuestionarioEmpresaPage;
